import { render, staticRenderFns } from "./ServiceAreasSection.vue?vue&type=template&id=2f598654&scoped=true"
import script from "./ServiceAreasSection.vue?vue&type=script&lang=js"
export * from "./ServiceAreasSection.vue?vue&type=script&lang=js"
import style0 from "./ServiceAreasSection.vue?vue&type=style&index=0&id=2f598654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f598654",
  null
  
)

export default component.exports